import React from 'react';
import DocumentMeta from 'react-document-meta';
import { Link } from 'react-router-dom';
import FoodDetail from '../components/FoodDetail';
import products from '../data/shopProducts';
import useCart from '../hooks/useCart';
import styles from '../styles/ProductDetail.module.css';

const publicUrl = process.env.PUBLIC_URL || '';

const ProductDetail = ({ match }) => {
  const { addItem } = useCart();
  const product = products.find(item => item.id === match.params.productId);

  if (!product) {
    return (
      <main className={styles.notFound}>
        <h1>Product not found</h1>
        <Link to={`${publicUrl}/Shop`}>Back to shop</Link>
      </main>
    );
  }

  const addProductToCart = (item, quantity) => {
    for (let index = 0; index < quantity; index += 1) {
      addItem(item);
    }
  };

  return (
    <DocumentMeta
      title={`${product.name} | Grain Bites`}
      description={product.description}
    >
      <FoodDetail
        title={product.name}
        image={product.image}
        price={`${product.price.toFixed(2).replace('.', ',')} €`}
        description={product.description}
        ingredients={product.ingredients}
        categories={[product.category]}
        product={product}
        onAddToCart={addProductToCart}
      />
    </DocumentMeta>
  );
};

export default ProductDetail;
